import { render, staticRenderFns } from "./BannerWeLove.vue?vue&type=template&id=270c1d28&scoped=true&"
import script from "./BannerWeLove.vue?vue&type=script&lang=js&"
export * from "./BannerWeLove.vue?vue&type=script&lang=js&"
import style0 from "./BannerWeLove.vue?vue&type=style&index=0&id=270c1d28&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270c1d28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
